import { Button } from "@mui/material";
import { isDev } from "app/helpers/environment";
import { ReactNode, useState } from "react";

import { ReactHookFormDebugEnabledContext } from "../context";

export const ReactHookFormDebugContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isEnabled, setIsEnabled] = useState(false);

  return (
    <ReactHookFormDebugEnabledContext.Provider value={isEnabled}>
      {children}
      {isDev() && (
        <Button
          onClick={() => {
            setIsEnabled(!isEnabled);
          }}
          sx={{
            backgroundColor: "white",
            border: isEnabled ? "2px solid" : "1px solid",
            borderRadius: "50%",
            bottom: 10,
            boxShadow: "0 0 4px black",
            color: isEnabled ? "success.main" : "primary",
            fontSize: isEnabled ? 12 : 10,
            height: 50,
            left: 10,
            minWidth: 50,
            overflow: "hidden",
            padding: 0,
            position: "fixed",
            width: 50,
            zIndex: 9999,
          }}
        >
          RHF
        </Button>
      )}
    </ReactHookFormDebugEnabledContext.Provider>
  );
};
